<!--
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-03-01 13:53:05
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-03-07 16:46:07
-->
<script lang="tsx" setup>
import { NAvatar, NDropdown, NScrollbar } from 'naive-ui'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore, useWorkspaceStore } from '@/store'
import type { workspaceItem } from '@/store/modules/workspace'
import { WorkspaceType } from '@/store/modules/workspace'
import { getPosthogPath } from '@/utils/tool'

const router = useRouter()
const route = useRoute()

const userStore = useUserStore()

const workspaceStore = useWorkspaceStore()
// 工作空间列表 包含个人空间
const workspaceList = computed(() => workspaceStore.workspaceList)

// 选择工作空间

const showDropdown = ref(false)

function toggleDrop() {
  showDropdown.value = !showDropdown.value
}

function onClickoutside(event: MouseEvent) {
  if (event.target === document.querySelector('.header-workspace')) {
    return
  }
  showDropdown.value = false
}

function changeCurrentWorkspace(item: workspaceItem) {
  if (item.workspaceType === WorkspaceType.Check) {
    // 审核中不能点击选中
    return
  }

  // workspaceStore.updateCurrentWorkspace(item)
  updateUrlWorkspaceQuery(String(item.workspaceId))
  showDropdown.value = false

  // 这些页面切换企业空间后，需要重定向当前页面，其他页面回到首页
  // 首页
  // 企业知识库/知识库
  // 企业灵感库
  // 提案工作台
  // AI一键提案
  // 方案验证
  // 提案管理
  // 平台知识库
  const redirectRoutes = ['WorkbenchView', 'Knowledge', 'ProposalView', 'ModeView', 'SelectProductView', 'ProductManageView', 'PlatformKnowledge']

  if (redirectRoutes.includes(route.name as string)) {
    if (route.fullPath.indexOf('workspace') > 0) {
      let url = route.fullPath
      url = url.replace(/(\?|\&)workspace=-?\d+/, (match, prefix) => {
        return `${prefix}workspace=${item.workspaceId}`
      })

      window.location.href = url
    }
  } else {
    router.replace({
      path: '/workbench',
      query: {
        workspace: item.workspaceId,
      },
    }).catch((err) => {
      if (err.name !== 'NavigationDuplicated') {
        console.error(err)
      }
    })
  }
}

function updateUrlWorkspaceQuery(id: string) {
  // 获取当前路由的所有查询参数
  const currentQuery = { ...route.query }

  // 设置或更新workspace参数
  currentQuery.workspace = id

  router.replace({ query: currentQuery }).catch((err) => {
    // 如果错误是NavigationDuplicated的实例，可以忽略它
    if (err.name !== 'NavigationDuplicated') {
      // 否则，可能是一个真正的错误，可以选择如何处理它
      console.error(err)
    }
  })
}

function getUpperCaseFirstLetter(name: string) {
  return Array.from(name).slice(0, 1)[0].toUpperCase()
}

const firstLetter = computed(() => {
  return workspaceStore.isPersonal ? getUpperCaseFirstLetter(userStore.userInfo.nickName) : getUpperCaseFirstLetter(workspaceStore.currentWorkspace.workspaceName)
})

function onCreateCompay() {
  workspaceStore.updateCreateCompanyModal(true)
  toggleDrop()
}

function isVip(item: any) {
  // 1=已认证 10-vip企业 20-svip企业 90-svip定制
  return item.vipState === 1 || item.vipState === 10 || item.vipState === 20 || item.vipState === 90
}
document.addEventListener('click', () => {
  showDropdown.value = false
})

// 下拉框内容
function renderDropInfo() {
  return <div>
    <NScrollbar style="max-height: 280px">
      <ul class="workspace-list">
        {workspaceList.value.map((item: workspaceItem) => {
          const isActive = item.workspaceId === workspaceStore.currentWorkspace.workspaceId
          const isPersonal = item.workspaceType === WorkspaceType.Personal
          const firstLetter = isPersonal ? getUpperCaseFirstLetter(userStore.userInfo.nickName) : getUpperCaseFirstLetter(item.workspaceName)

          const logoHtml = (isVip(item) && item.logo) ? <NAvatar round size={28} src={item.logo} class="mr-[8px]"></NAvatar> : <span class="icon" >{firstLetter}</span>

          return <li class={['workspace-item', { active: isActive }, { 'is-company': item.workspaceType === WorkspaceType.Company }, { disabled: item.workspaceType === WorkspaceType.Check }]} key={item.workspaceName} data-ph-capture-attribute-page-actions={getPosthogPath(['顶部导航栏', '切换空间', item.workspaceName])} onClick={() => changeCurrentWorkspace(item)}>
            {logoHtml}
            <span class="name ellipsis" title={item.workspaceName}>{item.workspaceName}</span>
            <span class="right">
              {isVip(item) ? <span class="is-vip"><i class="vip-icon"></i>已认证</span> : ''}
              {item.workspaceType === WorkspaceType.Check ? <span class="workspace-check">审核中</span> : <i class="checker" />}
            </span>
          </li>
        })}
      </ul>
    </NScrollbar>
    {/* <ul class="workspace-list">
      <li>
        <button class="create-btn" data-ph-capture-attribute-page-actions={getPosthogPath(['顶部导航栏', '切换空间', '创建新企业'])} onClick={onCreateCompay}>
          <i class="icon" />
          <span class="name" >
            创建新企业
          </span>
        </button>
      </li>
    </ul> */}
  </div>
}
const options = [
  {
    key: 'user',
    type: 'render',
    render: renderDropInfo,
  },
]

const workspaceName = computed(() => {
  return workspaceStore.currentWorkspace?.workspaceName
})
const workspaceType = computed(() => {
  return workspaceStore.currentWorkspace?.workspaceType
})
const currentWorkspace = computed(() => {
  return workspaceStore.currentWorkspace
})

const isShow = computed(() => {
  if (workspaceList.value.length) {
    const hasPersonalSpace = workspaceList.value.find(item => item.workspaceId === Number(route.query.workspace))
    if ((route.path.includes('productDetailMain') || route.path.includes('createProduct')) && !hasPersonalSpace) {
      // 产品详情页，被邀请成功后，没有个人空间也可以查看，但不显示切换空间
      return false
    } else {
      return true
    }
  } else {
    return false
  }
})


</script>

<template>
  <NDropdown v-if="isShow" class="user-workspace-dropdown" :show="showDropdown" placement="bottom-start"
    :options="options" :disabled="workspaceList.length === 1" @clickoutside="onClickoutside($event)">
    <div class="header-workspace" :class="{ 'is-open': showDropdown }"
      :data-ph-capture-attribute-page-actions="getPosthogPath(['顶部导航栏', '切换空间'])" @click.stop="toggleDrop">
      <NAvatar v-if="isVip(currentWorkspace) && currentWorkspace?.logo" class="mr-[8px]" round :size="28"
        :src="currentWorkspace?.logo" />
      <span v-else class="icon">{{ firstLetter }}</span>
      <span class="name ellipsis">{{ workspaceName }}</span>
      <span v-if="isVip(currentWorkspace)" class="is-vip"><i class="vip-icon" />已认证</span>
      <span v-if="workspaceType === WorkspaceType.Check" class="workspace-check">审核中</span>
      <i class="arrow" />
    </div>
  </NDropdown>
</template>

<style lang="scss">
.header-workspace {
  padding: 4px 12px 4px 6px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: #ECF0FB;
  border-radius: 90px;
  opacity: 1;
  border: 1px solid transparent;
  box-sizing: border-box;

  &:hover {
    border-color: #4050FF;

  }

  &.is-open {
    border-color: #4050FF;

    .arrow {
      transform: rotate(180deg);
    }
  }

  .icon,
  .name,
  .arrow {
    pointer-events: none;
  }

  .icon {
    margin-right: 8px;
    width: 28px;
    height: 28px;
    background: #4050FF;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    font-size: 14px;
    line-height: 28px;
  }

  .name {
    max-width: 152px;
    line-height: 26px;
  }

  .is-vip {
    display: inline-flex;
    align-items: center;
    background: #202741;
    border-radius: 20px;
    padding: 0 4px;
    margin: 0 0 0 4px;
    font-weight: 500;
    font-size: 11px;
    color: #F8E0C7;
    line-height: 18px;

    .vip-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      margin: 2px 2px 0 0;
      background: url('./icons/vip-icon.png') no-repeat;
      background-size: contain;
    }
  }

  .workspace-check {
    width: 41px;
    height: 18px;
    margin-left: 8px;
    background: #FFA600;
    border-radius: 8px;
    font-size: 11px;
    color: #FFFFFF;
    line-height: 18px;
    text-align: center;
  }

  .arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    background-image: url('./icons/arrow-down.png');
    background-size: cover;
    transition: all cubic-bezier(0.075, 0.82, 0.165, 1) .5s;
  }
}

.user-workspace-dropdown {
  .workspace-list {
    padding: 4px;
    background-color: #fff;
    border-radius: 4px;

    .workspace-item {
      padding: 0 8px 0 12px;
      height: 56px;
      display: flex;
      align-items: center;
      cursor: pointer;
      // border-bottom: 1px solid #E6E6E6;

      &:last-child {
        border-bottom-color: transparent;
      }

      &+.workspace-item {
        margin-top: 4px;
      }

      .icon {
        margin-right: 8px;
        width: 28px;
        height: 28px;
        background: #4050FF;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        font-size: 14px;
        line-height: 28px;
      }

      &:hover {
        background-color: #F0F5FF;
        border-bottom-color: transparent;
      }

      &.active {
        background-color: #F0F5FF;
        border-radius: 4px;
        border-bottom-color: transparent;

        // .right {
        //   .checker {
        //     display: block;
        //   }
        // }
      }

      &.disabled {
        background-color: transparent;
        cursor: not-allowed;
      }

      .name {
        flex: 1;
        width: 152px;
        font-size: 14px;
        font-weight: 400;
        color: #242F57;
      }

      .right {
        // width: 36px;
        display: flex;
        align-items: center;
        justify-content: center;

        .is-vip {
          display: inline-flex;
          align-items: center;
          background: #202741;
          border-radius: 20px;
          padding: 0 4px;
          margin: 0 0 0 4px;
          font-weight: 500;
          font-size: 11px;
          color: #F8E0C7;
          line-height: 18px;

          .vip-icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            margin: 2px 2px 0 0;
            background: url('./icons/vip-icon.png') no-repeat;
            background-size: contain;
          }
        }

        .workspace-check {
          width: 41px;
          height: 18px;
          margin: 0 0 0 4px;
          background: #FFA600;
          border-radius: 8px;
          font-size: 11px;
          color: #FFFFFF;
          line-height: 18px;
          text-align: center;
        }

        .checker {
          display: none;
          width: 16px;
          height: 16px;
          background-image: url('./icons/checker.png');
          background-size: cover;
        }
      }
    }
  }

  .create-btn {
    display: flex;
    align-items: center;
    border-radius: 4px;
    height: 48px;
    width: 100%;

    &:hover {
      background: #F0F5FF;
    }

    .icon {
      flex: 0 0 20px;
      width: 20px;
      height: 20px;
      margin-left: 24px;
      margin-right: 16px;
      background: url('./icons/create-btn.png') no-repeat;
      background-size: contain;
    }

    .name {
      color: #425466;
    }
  }
}
</style>
